export class AjaxResponder {
    constructor(requestData, callback) {
        this._requestData = requestData;
        this._callback = callback;
        this._data = [];
        this._total = null;
        this._filtered = null;
    }

    from(data) { this._data = data; return this; }
    withTotal(total) { this._total = total; return this; }
    withFiltered(filtered) { this._filtered = filtered; return this; }

    send() {
        this._callback({
            draw: this._requestData.draw,
            recordsTotal: this._total !== null ? this._total : this._data.length,
            recordsFiltered: this._filtered !== null ? this._filtered : (this._total !== null ? this._total : this._data.length),
            data: this._data
        });
    }
}
